
export default {
  data() {
    return {
      address: null,
      activeYear: null,
      activeMonth: null,
      houseNumber: null,
      activeToday: null,
      livingInBuilding: null,
      deliveryScheduleResults: [],
      livingOptions: [
        {
          id: `living-${1}`,
          name: this.$t("text.yes"),
          value: 1,
        },
        {
          id: `living-${2}`,
          name: this.$t("text.no"),
          value: 0,
        },
      ],
      filters: [
        {
          id: 1,
          name: this.$t("text.communal"),
          color: "#6BA87F",
          checked: true,
        },
        {
          id: 2,
          name: this.$t("text.paper"),
          color: "#688EC4",
          checked: true,
        },
        {
          id: 3,
          name: this.$t("text.plastic"),
          color: "#DECA7C",
          checked: true,
        },
        {
          id: 4,
          name: this.$t("text.metal"),
          color: "#A3A3A3",
          checked: true,
        },
        {
          id: 5,
          name: this.$t("text.bioWaste"),
          color: "#B28670",
          checked: true,
        },
        {
          id: 6,
          name: this.$t("text.glass"),
          color: "#92C9BC",
          checked: true,
        },
      ],
      options: [
        {
          name: "link",
          label: this.$t("label.link"),
          type: "link",
        },
      ],
    };
  },
  watch: {
    filters: {
      handler: function () {
        this.getAddressDeliverySchedule();
      },
      deep: true,
    },
  },
  mounted() {
    const date = new Date();
    this.activeMonth = date.getMonth() + 1;
    this.activeYear = date.getFullYear();
  },
  methods: {
    returnDate() {
      switch (this.activeMonth) {
        case 1:
          return `Siječanj, ${this.activeYear}.`;
        case 2:
          return `Veljača, ${this.activeYear}.`;
        case 3:
          return `Ožujak, ${this.activeYear}.`;
        case 4:
          return `Travanj, ${this.activeYear}.`;
        case 5:
          return `Svibanj, ${this.activeYear}.`;
        case 6:
          return `Lipanj, ${this.activeYear}.`;
        case 7:
          return `Srpanj, ${this.activeYear}.`;
        case 8:
          return `Kolovoz, ${this.activeYear}.`;
        case 9:
          return `Rujan, ${this.activeYear}.`;
        case 10:
          return `Listopad, ${this.activeYear}.`;
        case 11:
          return `Studeni, ${this.activeYear}.`;
        case 12:
          return `Prosinac, ${this.activeYear}.`;
        default:
          return `${this.activeMonth}.${this.activeYear}.`;
      }
    },

    prevMonth() {
      this.getAddressDeliverySchedule(true, false);
    },
    nextMonth() {
      this.getAddressDeliverySchedule(false, true);
    },

    removeSelection() {
      this.address = null;
      this.houseNumber = null;
      this.activeToday = null;
      this.livingInBuilding = null;
      this.deliveryScheduleResults = [];

      const date = new Date();
      this.activeMonth = date.getMonth() + 1;
      this.activeYear = date.getFullYear();

      this.filters.forEach((filter) => {
        if (!filter.checked) {
          filter.checked = true;
        }
      });
    },

    getDeliverySchedule(address) {
      this.address = address;
    },

    checkIfDeliveryToday() {
      const date = new Date();
      const currentDay = date.getDate();
      const currentMonth = date.getMonth();
      const currentYear = date.getFullYear();

      const currentDate = `${currentDay}.${currentMonth + 1}.${currentYear}`;

      if (
        !this.deliveryScheduleResults ||
        !this.deliveryScheduleResults.weeks ||
        !this.deliveryScheduleResults.weeks.length
      )
        return;

      this.activeToday = this.deliveryScheduleResults.weeks.filter((result) => {
        if (result.date === currentDate) {
          return result.date;
        }
      });

      if (this.activeToday && this.activeToday.length) {
        this.activeToday = this.activeToday[0];
      }
    },

    async getAddressDeliverySchedule(prevMonth = false, nextMonth = false) {
      if (!this.address) return;

      try {
        var tank = [];

        this.filters.forEach((filter) => {
          if (filter.checked) {
            tank.push(`&spremnik[]=${filter.name}`);
          }
        });

        tank = tank.toString();
        tank = tank.replaceAll(",", "");

        if (nextMonth) {
          this.activeMonth = this.activeMonth === 12 ? 1 : this.activeMonth + 1;

          this.activeYear =
            this.activeMonth === 1 ? this.activeYear + 1 : this.activeYear;
        } else if (prevMonth) {
          this.activeMonth =
            this.activeMonth === 1
              ? 12
              : (this.activeYear, this.activeMonth - 2, this.activeMonth - 1);

          this.activeYear =
            this.activeMonth === 12 ? this.activeYear - 1 : this.activeYear;
        }

        const data = await this.$axios.get(
          `https://api.unikom.hr/api/unikom/planOdvozaOpen?address=${
            this.address.ulica
          }&city=${this.address.mjesto}&building=${
            this.livingInBuilding ? 1 : 0
          }&number=${this.houseNumber}&month=${this.activeMonth}&year=${
            this.activeYear
          }${tank}`
        );

        if (data && data.data) {
          this.deliveryScheduleResults = data.data;
          this.checkIfDeliveryToday();
        }
      } catch (err) {
        this.$toast.error(this.$t("toast.error"));
        console.log(err);
      }
    },

    returnArray(arr) {
      if (!arr || !arr.length) return;
      const trashArray = arr.split(",");

      return trashArray;
    },
  },
};
